import { EventGroupFormatsEnum } from 'types/generated/client';

const groupFormatToName: Record<EventGroupFormatsEnum, string> = {
  [EventGroupFormatsEnum.RoundRobin]: 'Round Robin',
  [EventGroupFormatsEnum.SingleElimination]: 'Single Elimination',
  [EventGroupFormatsEnum.RoundRobinSingleElimination]: 'Round Robin + Single Elimination',
  [EventGroupFormatsEnum.Custom]: 'Custom',
  [EventGroupFormatsEnum.VairRoundRobin]: 'VAIR Round Robin',
  [EventGroupFormatsEnum.League]: 'League',
};

export function getGroupFormatName(groupFormat?: EventGroupFormatsEnum | null) {
  return groupFormat ? groupFormatToName[groupFormat] : '';
}
